import { render, staticRenderFns } from "./FeedProductDetailPage.vue?vue&type=template&id=78ea2d62&"
import script from "./FeedProductDetailPage.vue?vue&type=script&lang=ts&"
export * from "./FeedProductDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports